import React, { useState } from "react";
import { Select, Typography } from "antd";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import * as pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css"; // Importation des styles du plugin
import { FileOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Title } = Typography;
const FileSelector = ({ pdfFiles, selectedFile, onFileChange }) => (
  <Select
    style={{ width: 600, marginBottom: 16 }}
    placeholder="Sélectionner un fichier PDF"
    onChange={onFileChange}
    value={selectedFile}
  >
    {pdfFiles.map((file, index) => (
      <Option key={index} value={file.file}>
        {file.name}
      </Option>
    ))}
  </Select>
);

const PdfViewer = ({ file }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  try {
    return (
      <div style={{ height: "700px" }}>
        <Worker workerUrl={pdfjsWorker}>
          <Viewer fileUrl={`/Pdf/${file}`} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      </div>
    );
  } catch (error) {
    console.error("Erreur lors du chargement du PDF:", error);
    return <div>Erreur lors du chargement du PDF. Veuillez réessayer.</div>;
  }
};

const TextReglement = () => {
  const pdfFiles = [
    { name: "Tarifs Hôpital Principal 2006", file: "TARIFS HOPITAL PRINCIPAL 2006.pdf" },
    { name: "Statuts IPM Nouveau", file: "STATUTS IPM NOUVEAU.pdf" },
    { name: "Ratios de gestion IPM", file: "Ratios de gestion IPM.pdf" },
    { name: "Plan Comptable SYSCOHADA", file: "PLAN COMPTABLE SYSCOHADA.pdf" },
    { name: "Plan Comptable CIPRES des OSS", file: "Plan Comptable CIPRES des OSS.pdf" },
    { name: "Nomenclature des Actes Médicaux Syndicat des Médecins Privés du Sénégal", file: "NOMENCLATURE DES ACTES MEDICAUX SYNDICAT DES MEDECINS PRIVES DU SENEGAL.pdf" },
    { name: "Médecine d’Entreprise", file: "MEDCINE D'ENTREPRISE.pdf" },
    { name: "Loi 75-50 du 03 Avril 1975 portant IPS", file: "LOI 75-50 DU 03 AVRIL 1975 PORTANT IPS.pdf" },
    { name: "Journal Officiel - Tarif des Actes Hôpitaux Sénégal", file: "JO Tarif des Actes HOPITAUX SENEGAL.pdf" },
    { name: "Nouveau Décret IPM 2012", file: "NOUVEAU DECRET IPM 2012_832 DU 07_08_2012.pdf" },
    { name: "Formulaire Appel Cotisations ICAMO", file: "FORMULAIRE APPEL COTISATIONS ICAMO.pdf" },
    { name: "Fiche de Renseignement IPM", file: "FICHE DE RENSEIGNEMENT IPM.pdf" },
    { name: "Barème Mensuel IR 2013", file: "barememensuel-ir_2013_idcomplet.pdf" },
    { name: "Arrêté 002632 du 19 Avril 2009", file: "ARRETE 002632 DU 19 avril 200...ES ACTES MEDICAUX AUX IPM.pdf" },
    { name: "Barème des Salaires", file: "BAREME DES SALAIRES.pdf" },
  ];

  const [selectedFile, setSelectedFile] = useState(pdfFiles[0].file);

  const handleFileChange = (value) => {
    setSelectedFile(value);
  };

  return (
    <div style={{ padding: 12 }}>
      <Title level={3} style={{ marginTop: "2px" }}>
        <FileOutlined style={{ color: "#1f4ea1", fontSize: 28 }} />
        <strong>Texte & Réglements</strong>
      </Title>
      <FileSelector pdfFiles={pdfFiles} selectedFile={selectedFile} onFileChange={handleFileChange} />
      <PdfViewer file={selectedFile} />
    </div>
  );
};

export default TextReglement;
